import React from 'react'
import PropTypes from 'prop-types'

import { Button, Dropdown, Popup } from 'semantic-ui-react'

import Permissions from 'Components/Permissions'
import PopupButton from 'Components/PopupButton'
import SortingDropdownItem from 'Components/SortingDropdownItem'

import { getSortByIcon } from 'Global/Helpers/iconHelpers'
import * as styles from './styles'

const LayoutButtonGroup = props => {
  const { exportToExcel, handleSort, layout, limit, noExport, noLayout, sortBy, sortOrder, toggleLayout, toggleLimit } = props

  return (
    <div style={styles.buttonGroup}>
      <Button.Group icon>
        {!noExport && (
          <Permissions
            permissions="general.excelExport"
            render={() => (
              <PopupButton onClick={exportToExcel} popupContent="Export Results to Excel (Limited to 1000)" icon="file excel outline" />
            )}
          />
        )}

        {layout === 'gridLayout' && (
          <Popup
            content="Sorting"
            size="mini"
            trigger={
              <Dropdown icon={getSortByIcon(sortBy)} button floating>
                <Dropdown.Menu>
                  <SortingDropdownItem
                    active={sortBy === 'id'}
                    icon="hashtag"
                    handleSort={handleSort}
                    name="id"
                    sortOrder={sortOrder}
                    text="ID"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'name'}
                    icon="tag"
                    handleSort={handleSort}
                    name="name"
                    sortOrder={sortOrder}
                    text="Name"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'status'}
                    icon="shopping basket"
                    handleSort={handleSort}
                    name="status"
                    sortOrder={sortOrder}
                    text="Status"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'sizeQm'}
                    icon="expand"
                    handleSort={handleSort}
                    name="sizeQm"
                    sortOrder={sortOrder}
                    text="Size (qm)"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'quality'}
                    icon="share alternate"
                    handleSort={handleSort}
                    name="quality"
                    sortOrder={sortOrder}
                    text="Quality"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'dessin'}
                    icon="block layout"
                    handleSort={handleSort}
                    name="dessin"
                    sortOrder={sortOrder}
                    text="Edges"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'producer'}
                    icon="factory"
                    handleSort={handleSort}
                    name="producer"
                    sortOrder={sortOrder}
                    text="Producer"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'customer'}
                    icon="user"
                    handleSort={handleSort}
                    name="customer"
                    sortOrder={sortOrder}
                    text="Customer"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'pictureSource'}
                    icon="camera"
                    handleSort={handleSort}
                    name="pictureSource"
                    sortOrder={sortOrder}
                    text="Primary Picture Source"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'dateOrder'}
                    icon="calendar"
                    handleSort={handleSort}
                    name="dateOrder"
                    sortOrder={sortOrder}
                    text="Order Date"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'dateReceipt'}
                    icon="add to calendar"
                    handleSort={handleSort}
                    name="dateReceipt"
                    sortOrder={sortOrder}
                    text="Receipt Date"
                  />

                  <SortingDropdownItem
                    active={sortBy === 'dateScanned'}
                    icon="calendar check"
                    handleSort={handleSort}
                    name="dateScanned"
                    sortOrder={sortOrder}
                    text="Scan Date"
                  />
                </Dropdown.Menu>
              </Dropdown>
            }
          />
        )}

        <PopupButton onClick={toggleLimit} popupContent="Results per Page" text={limit.toString()} />

        {!noLayout && <PopupButton onClick={toggleLayout} popupContent="Layout" icon={layout === 'gridLayout' ? 'table' : 'grid layout'} />}
      </Button.Group>
    </div>
  )
}

LayoutButtonGroup.propTypes = {
  exportToExcel: PropTypes.func,
  handleSort: PropTypes.func.isRequired,
  layout: PropTypes.string,
  limit: PropTypes.number.isRequired,
  noExport: PropTypes.bool,
  noLayout: PropTypes.bool,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  toggleLayout: PropTypes.func,
  toggleLimit: PropTypes.func.isRequired,
}

LayoutButtonGroup.defaultProps = {
  exportToExcel: () => '',
  noExport: false,
  noLayout: false,
  toggleLayout: () => '',
}

export default LayoutButtonGroup
